export function convertFilterValue(value: number) {
  return +(value * 100).toFixed(1);
}
